import Hls from 'hls.js';
import EventBus from '@/core/event-bus';
import { HlsErrorHandler, emitToClient } from '.';
import SmvpErrorHandler, { ErrorData } from './smvp-error-handler';

const MAX_FATAL_INTERVAL = 3000;
const TOTAL_STEPS = 3;

const handleFatal = (
    hls: Hls,
    eventBus: EventBus,
    smvpErrorHandler: SmvpErrorHandler,
    step: number,
    event: string,
    data: ErrorData
) => {
    switch (step) {
        case 0:
            console.error(`[Hls] fatal ${data?.details} encountered. Trying to recover with startLoad()`, { event, data });

            hls.startLoad();

            break;
        case 1:
            console.error(`[Hls] fatal ${data?.details} encountered. Trying to recover with recoverMediaError()`, { event, data });

            hls.recoverMediaError();

            break;
        case 2:
            console.error(`[Hls] fatal ${data?.details} encountered. Could not recover. Emitting to client`, { event, data });

            smvpErrorHandler.smvpFatalEmit(event, data);

            break;
    }
};

export default function onBufferStalled(
    hls: Hls,
    eventBus: EventBus,
    smvpErrorHandler: SmvpErrorHandler,
): HlsErrorHandler {
    let fatalCount = 0;
    let lastFatal = -Infinity;

    return (
        event: string,
        data: ErrorData
    ) => {
        if (data.fatal) {
            const delta = Date.now() - lastFatal;

            fatalCount = delta > MAX_FATAL_INTERVAL
                ? 0
                : (fatalCount + 1) % TOTAL_STEPS;

            handleFatal(hls, eventBus, smvpErrorHandler, fatalCount, event, data);

            lastFatal = Date.now();
        } else {
            console.warn(`[Hls] ${data?.details} encountered. Emitting to client`, { event, data });
        }

        emitToClient(hls, eventBus, event, data);
    };
}
